<template>
  <div
    :class="{ 'container-wide': lgAndUp || xlAndUp }"
    class="container-top mt-5"
  >
    <div>
      <div class="d-flex flex-column flex-sm-row justify-content-sm-between">
        <div>
          <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
            {{
              navigatorLang === "en-US"
                ? "New Converts"
                : $t("people.newConverts")
            }}
          </div>
          <!-- <div class="s-18">
            {{
              navigatorLang === "en-US"
                ? "Showing all New Converts"
                : $t("people.showNewConverts")
            }}
          </div> -->
        </div>
        <div class="d-flex flex-wrap flex-sm-nowrap mt-3 mt-sm-0">
          <!-- <el-button
            color="#FF0F00"
            round
            class="d-flex w-100"
            @click="watchVideo"
          >
            <span class="mt-0 mr-1 text-white">
              <VideoPlayIcon />
            </span>
            <span class="s-13 text-white">
              {{
                navigatorLang === "en-US"
                  ? "Watch Video"
                  : $t("people.watchVideo")
              }}
            </span>
          </el-button> -->
          <el-dropdown
            trigger="click"
            class="align-items-center justify-content-center d-flex ml-md-3 ml-0 default-btn2 py-0 m-0 border"
            style="height: 2.2rem"
          >
            <span
              class="el-dropdown-link w-100 primary--text text-center font-weight-600"
            >
              {{ navigatorLang === "en-US" ? "More" : $t("people.more") }}
              <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <!-- <el-dropdown-item class="text-black" @click="copylink"
                >Copy Public Link
                <img class="ml-2" src="../../assets/copyurl-icon.png" alt="" />
              </el-dropdown-item> -->
                <!-- <el-dropdown-item @click="getQrCode" class="text-black">
                Show QR Code
              </el-dropdown-item> -->
                <!-- <el-dropdown-item class="text-black" @click="showAnalysis"
                  >Analysis</el-dropdown-item
                > -->
                <el-dropdown-item class="text-black" @click="importNewConvert">
                  {{
                    navigatorLang === "en-US" ? "Import" : $t("people.Import")
                  }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <!-- <el-button @click="importMembers" class="header-btn secondary-button" round>Import</el-button> -->
          <el-button
            :color="primarycolor"
            class="ml-sm-2 ml-0 mt-2 mt-sm-0 w-100 header-btn"
            round
            @click="showAddConvertDialog = true"
          >
            {{
              navigatorLang === "en-US"
                ? "Add New Convert"
                : $t("people.addNewConvert")
            }}
          </el-button>
        </div>
      </div>
      <div class="col-md-12 mt-2 px-0">
        <div
          class="d-flex align-items-center w-100 cursor-pointer"
          @click="watchVideo"
        >
          <span class="mr-1 text-white">
            <VideoPlayIcon />
          </span>
          <span class="s-13 text-dak font-weight-600">
            <u>
              {{
                navigatorLang === "en-US"
                  ? "Watch Video"
                  : $t("people.watchVideo")
              }}
            </u>
          </span>
        </div>
      </div>
      <div class="row" v-if="false">
        <div class="col-md-2">
          <div class="font-weight-bold py-md-2 mt-4">
            {{ navigatorLang === "en-US" ? "QR Code" : $t("people.QRCode") }}
          </div>
          <div class="image" @click="getQrCode">
            <img src="../../assets/group2.svg" alt="First Timer image" />
          </div>
        </div>
        <div class="col-md-10 pl-0">
          <div class="font-weight-bold py-md-2 mt-4">
            {{
              navigatorLang === "en-US"
                ? "Share the link to your new converts to enable them to add their details to your church."
                : $t("people.shareNewConvertLink")
            }}
          </div>
          <div class="p-inputgroup form-group mt-1">
            <el-input
              v-model="newConvertLink"
              placeholder="Click the copy button when the link appears"
              ref="selectedLink"
              class="input-with-select w-100"
            >
              <template #append>
                <el-button @click="copylink2">
                  <el-icon>
                    <CopyDocument />
                  </el-icon>
                </el-button>
              </template>
            </el-input>
          </div>
        </div>
      </div>
      <transition name="el-fade-in-linear">
        <div class="row" v-show="membershipCapacityExceeded">
          <div class="col-md-12 mt-3">
            <MemberCapExceeded />
          </div>
        </div>
      </transition>
      <div class="tab-options d-block d-md-none mt-5">
        <div class="s-14 fw-500 col-md-10 px-0 mt-5">
          <div
            class="d-flex flex-column flex-sm-row justify-content-md-between"
          >
            <div>
              <el-tooltip
                class="box-item d-flex"
                effect="dark"
                v-if="marked.length > 0"
                content="Delete member(s)"
                placement="top-start"
              >
                <el-icon
                  :size="28"
                  class="ml-2 c-pointer primary--text"
                  v-if="marked.length > 0"
                  @click="showConfirmModal1"
                >
                  <Delete />
                </el-icon>
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="marked.length > 0"
                content="Send SMS"
                placement="top-start"
              >
                <img
                  src="../../assets/ChatCenteredDots.png"
                  style="width: 32px; margin-top: -20px"
                  class="ml-2 c-pointer"
                  @click="sendMarkedMemberSms"
                  alt="Send SMS"
                />
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="marked.length > 0"
                content="Send Email"
                placement="top-start"
              >
                <el-icon
                  :size="28"
                  class="ml-2 c-pointer primary--text"
                  v-if="marked.length > 0"
                  @click="sendMarkedMemberEmail"
                >
                  <Message />
                </el-icon>
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="marked.length > 0"
                content="Send Whatsapp message"
                placement="top-start"
              >
                <img
                  src="../../assets/WhatsappLogo.png"
                  style="width: 32px; margin-top: -20px"
                  class="ml-2 c-pointer"
                  @click="displayWhatsappDrawer(null)"
                  alt="Send Whatsapp message"
                />
              </el-tooltip>
            </div>
            <!-- <div
              class="d-flex flex-column flex-sm-row justify-content-md-between"
            >
              <el-input
                size="small"
                v-model="searchText"
                placeholder="Search..."
                class="search-input"
              >
                <template #suffix>
                  <el-button
                    style="padding: 5px; height: 22px"
                    @click.prevent="searchText = ''"
                  >
                    <el-icon :size="13">
                      <Close />
                    </el-icon>
                  </el-button>
                </template>
                <template #append>
                  <el-button class="btn-search">
                    <el-icon :size="13">
                      <Search />
                    </el-icon>
                  </el-button>
                </template>
              </el-input>
              <div
              style="background: #eeeeee"
              class="ml-2 mt-3 mt-sm-0 d-flex w-50 align-items-center justify-content-center border-radius-8"
            >
              <div
                @click="toggleFilterFormVissibility"
                class="mb-0 px-3 d-flex my-3 my-sm-0 c-pointer"
              >
                <span class="mr-1"> Filter</span>
                <el-icon :size="18">
                  <Filter />
                </el-icon>
              </div>
            </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="tab-options d-none d-md-block mt-5">
        <div class="table-top col-12 col-md-7 col-lg-7 col-xl-8 px-0 mt-5">
          <div
            class="d-flex flex-column flex-md-row justify-content-md-between"
          >
            <div>
              <el-tooltip
                class="box-item d-flex"
                effect="dark"
                v-if="marked.length > 0"
                content="Delete member(s)"
                placement="top-start"
              >
                <el-icon
                  :size="28"
                  class="ml-2 c-pointer primary--text"
                  v-if="marked.length > 0"
                  @click="showConfirmModal1"
                >
                  <Delete />
                </el-icon>
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="marked.length > 0"
                content="Send SMS"
                placement="top-start"
              >
                <img
                  src="../../assets/ChatCenteredDots.png"
                  style="width: 32px; margin-top: -20px"
                  class="ml-2 c-pointer primary--text"
                  @click="sendMarkedMemberSms"
                  alt="Send SMS"
                />
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="marked.length > 0"
                content="Send Email"
                placement="top-start"
              >
                <el-icon
                  :size="28"
                  class="ml-2 c-pointer primary--text"
                  v-if="marked.length > 0"
                  @click="sendMarkedMemberEmail"
                >
                  <Message />
                </el-icon>
              </el-tooltip>
              <el-tooltip
                class="box-item"
                effect="dark"
                v-if="marked.length > 0"
                content="Send Whatsapp message"
                placement="top-start"
              >
                <img
                  src="../../assets/WhatsappLogo.png"
                  style="width: 32px; margin-top: -20px"
                  class="ml-2 c-pointer primary--text"
                  @click="displayWhatsappDrawer(null)"
                  alt="Send Whatsapp message"
                />
              </el-tooltip>
            </div>
            <!-- <div
              class="d-flex flex-column flex-md-row justify-content-md-between"
            >
              <el-input
                size="small"
                v-model="searchText"
                placeholder="Search..."
                class="search-input col-md-12 col-9"
              >
                <template #suffix>
                  <el-button
                    style="padding: 5px; height: 22px"
                    @click.prevent="searchText = ''"
                  >
                    <el-icon :size="13">
                      <Close />
                    </el-icon>
                  </el-button>
                </template>
                <template #append>
                  <el-button class="btn-search">
                    <el-icon :size="13">
                      <Search />
                    </el-icon>
                  </el-button>
                </template>
              </el-input>
              <div
                style="background: #eeeeee"
                class="ml-2 mt-3 py-2 mt-md-0 d-flex align-items-center justify-content-center border-radius-8"
              >
                <p
                  @click="toggleFilterFormVissibility"
                  class="mb-0 px-3 d-flex my-3 my-sm-0 c-pointer"
                >
                  <span class="mr-1"> Filter</span>
                  <el-icon :size="18">
                    <Filter />
                  </el-icon>
                </p>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <TableSearch
        :data="searchNewConvert"
        :headers="NewConvertHeaders"
        @update:searchText="handleSearchTextUpdate"
        :checkMultipleItem="true"
        :filterItem="false"
        @checkedrow="handleSelectionChange"
      >
        <template v-slot:fullname="{ item }">
          <div @click="showMemberRow(item)" class="c-pointer">
            {{ item.fullName }}
          </div>
        </template>

        <template v-slot:phoneNumber="{ item }">
          <div @click="showMemberRow(item)" class="c-pointer">
            {{ item.phoneNumber }}
          </div>
        </template>

        <template v-slot:date="{ item }">
          <div @click="showMemberRow(item)" class="c-pointer">
            {{ formatDate(item.date) }}
          </div>
        </template>
        <!-- <template v-slot:lifeCycle="{ item }">
          <div @click="showMemberRow(item)" class="c-pointer">
            {{ item.lifeCycle }}
          </div>
        </template> -->
        <template v-slot:howDidYouAboutUsName="{ item }">
          <div @click="showMemberRow(item)" class="c-pointer">
            {{ item.howDidYouAboutUsName }}
          </div>
        </template>
        <template v-slot:interactions="{ item }">
          <div @click="showMemberRow(item)" class="c-pointer">
            {{ item.interactions }}
          </div>
        </template>

        <template v-slot:action="{ item }">
          <el-dropdown trigger="click">
            <el-icon>
              <MoreFilled />
            </el-icon>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="displayWhatsappDrawer(item)">
                  <div class="text-color">
                    {{
                      navigatorLang === "en-US"
                        ? "Send Whatsapp"
                        : $t("people.sendWhatsapp")
                    }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div class="text-color">
                    <router-link
                      :to="`/tenant/contactmanagement/${item.id}?memberType=2`"
                      class="text-color text-dark text-decoration-none"
                    >
                      {{
                        navigatorLang === "en-US"
                          ? "Follow Up"
                          : $t("people.followUp")
                      }}
                    </router-link>
                  </div>
                </el-dropdown-item>
                <!-- <el-dropdown-item>
                  <router-link
                    :to="`/tenant/people/addnewconvert?id=${item.id}`"
                    class="text-color"
                  >
                    {{ navigatorLang === "en-US" ? "Edit" : $t("people.edit") }}
                  </router-link>
                </el-dropdown-item> -->
                <el-dropdown-item>
                  <div
                    class="text-decoration-none text-color"
                    @click="showConfirmModal(item.id)"
                  >
                    {{
                      navigatorLang === "en-US" ? "Delete" : $t("people.delete")
                    }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </TableSearch>
    </div>
    <div
      v-if="allNewConvert.length === 0 && !loading && !networkError"
      class="no-person"
    >
      <div class="empty-img">
        <p><img src="../../assets/people/people-empty.svg" alt="" /></p>
        <p class="tip">
          {{
            navigatorLang === "en-US"
              ? "You haven't added any New Convert yet"
              : $t("people.addedNewConvertYet")
          }}
        </p>
        <el-button
          :color="primarycolor"
          @click="addNewConvert"
          class="ml-2 header-btn"
          round
        >
          {{
            navigatorLang === "en-US"
              ? "Add New Converts"
              : $t("people.addNewConvert")
          }}
        </el-button>
      </div>
    </div>
    <div v-else-if="networkError && !loading" class="adjust-network">
      <img src="../../assets/network-disconnected.png" />
      <div>
        {{
          navigatorLang === "en-US"
            ? "Opps, Your internet connection was disrupted"
            : $t("people.internetConnectionDisrupted")
        }}
      </div>
    </div>
    <el-drawer
      v-model="showSMS"
      :size="mdAndUp || lgAndUp || xlAndUp ? '70%' : '100%'"
      direction="rtl"
    >
      <template #header>
        <h4>
          {{ navigatorLang === "en-US" ? "Send SMS" : $t("people.sendSms") }}
        </h4>
      </template>
      <template #default>
        <div>
          <smsComponent
            :phoneNumbers="contacts"
            @closesidemodal="() => (showSMS = false)"
          />
        </div>
      </template>
    </el-drawer>

    <el-drawer
      v-model="showEmail"
      :size="mdAndUp || lgAndUp || xlAndUp ? '70%' : '100%'"
      direction="rtl"
    >
      <template #header>
        <h4>
          {{
            navigatorLang === "en-US" ? "Send Email" : $t("people.sendEmail")
          }}
        </h4>
      </template>
      <template #default>
        <div>
          <emailComponent
            :selectedGroupMembers="markedMembers"
            @closesidemodal="() => (showEmail = false)"
          />
        </div>
      </template>
    </el-drawer>

    <el-skeleton class="w-100" animated v-if="loading">
      <template #template>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 20px;
          "
        >
          <el-skeleton-item
            variant="text"
            style="width: 240px; height: 240px"
          />
          <el-skeleton-item
            variant="text"
            style="width: 240px; height: 240px"
          />
        </div>
        <el-skeleton
          class="w-100 mt-5"
          style="height: 25px"
          :rows="20"
          animated
        />
      </template>
    </el-skeleton>
    <el-dialog
      v-model="QRCodeDialog"
      title=""
      :width="mdAndUp || lgAndUp || xlAndUp ? `30%` : xsOnly ? `90%` : `70%`"
      class="QRCodeDialog"
      align-center
    >
      <div class="d-flex align-items-center flex-column">
        <h4 class="text-capitalize font-weight-600">
          {{
            navigatorLang === "en-US"
              ? "New Converts QR Code For Registration"
              : $t("people.newConvertQRCodeReg")
          }}
        </h4>
      </div>
      <div class="d-flex justify-content-center">
        <div class="img-wrapper">
          <img v-if="qrCode" :src="qrCode" class="image-wrapper w-100" />
        </div>
      </div>
    </el-dialog>
    <el-dialog
      style="border-radius: 20px"
      v-model="showAddMemberVideo"
      :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
      top
    >
      <div class="row justify-content-center" v-loading>
        <div class="col-md-12">
          <iframe
            sandbox="allow-downloads allow-scripts allow-same-origin"
            width="100%"
            height="315"
            :src="videoURL"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-model="showAddConvertDialog"
      title=""
      :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : xsOnly ? `90%` : `70%`"
      align-center
      class="border-radius-20"
    >
      <div class="row justify-content-center">
        <div class="col-md-12 text-center">
          <div class="font-weight-600 s-16 text-dark">Add New Convert</div>
        </div>
        <div class="col-md-12 mt-4 d-flex justify-content-center">
          <div class="col-12 col-md-7">
            <el-button
              :color="primarycolor"
              round
              class="w-100 py-4 text-white"
              @click="showSelectFromDB = true"
            >
              Select From Existing Database
            </el-button>
          </div>
        </div>
        <div class="col-md-12 mt-4 d-flex justify-content-center">
          <div class="col-12 col-md-7">
            <!-- Accordion for selecting from DB -->
            <el-collapse v-if="showSelectFromDB" class="border-t" accordion>
              <el-collapse-item title="Search and Select Member">
                <el-input
                  v-model="newSearchText"
                  placeholder="Enter at least 3 characters"
                  @input="searchForPerson"
                  clearable
                />
                <span v-if="loadingData">
                  <el-icon :size="20" class="is-loading"> <Loading /> </el-icon
                ></span>

                <div class="mt-2">
                  <div
                    class="cursor-pointer p-2"
                    v-for="(member, index) in memberSearchResults"
                    :key="index"
                    @click="selectMember(member)"
                  >
                    <span>{{ member.name }}</span>
                  </div>

                  <p
                    v-if="
                      !loadingData &&
                      newSearchText.length >= 3 &&
                      memberSearchResults.length === 0
                    "
                    class="text-gray-500 text-sm mt-2"
                  >
                    No match found
                  </p>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <div class="col-md-12 mt-3 d-flex justify-content-center">
          <div class="col-12 col-md-7">
            <el-button
              round
              class="secondary-button w-100 py-4"
              @click="goToAddNewConvert"
            >
              Create New One
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-drawer
      v-model="showWhatsapp"
      :size="mdAndUp || lgAndUp || xlAndUp ? '70%' : '100%'"
      direction="rtl"
      class="whatsappdrawer"
    >
      <template #header> </template>
      <template #default>
        <div v-if="whatsappClientState">
          <div class="d-flex justify-content-center align-items-center">
            <img src="../../assets/whatsappwhiteoutline.svg" />
            <h4 class="font-weight-700 text-dark mb-0 ml-2">
              {{
                navigatorLang === "en-US"
                  ? "Send Whatsapp message to"
                  : $t("people.sendWhatsappMessage")
              }}
            </h4>
          </div>
          <h4 class="text-center text-secondary font-weight-600">
            {{
              sendWhatsappToMultiple
                ? "Selected Members"
                : whatsappRecipient.firstName
            }}
          </h4>
        </div>
        <div v-if="whatsappClientState">
          <div>
            <div>
              {{
                navigatorLang === "en-US"
                  ? "Recipient"
                  : $t("people.recipient")
              }}{{ sendWhatsappToMultiple ? "s" : "" }}
              <el-tooltip
                class="box-item"
                effect="customized"
                content="<div>Make sure that the numbers are correctly formatted.</div> <div>A correct format should include the country code with the phone number. E.g +2349059403948.</div> <div>It works either with the '+' symbol or without it.</div>"
                raw-content
                placement="top"
              >
                <el-icon>
                  <InfoFilled />
                </el-icon>
              </el-tooltip>
            </div>
            <div
              class="d-flex align-items-center flex-wrap"
              v-if="sendWhatsappToMultiple"
            >
              <el-tag
                class="mx-1"
                size="large"
                closable
                v-for="(item, index) in marked
                  .filter((i) => i.mobilePhone)
                  .splice(0, 10)"
                :key="item.id"
                @close="marked.splice(index, 1)"
                >{{ item.mobilePhone }}</el-tag
              >
              <!-- <div class="multiple_numbers d-flex align-items-center mr-2 mt-2"
                v-for="(item, index) in marked.filter(i => i.mobilePhone).splice(0, 10)" :key="item.id">
                <span>{{ item.mobilePhone }}</span>
                <el-icon class="c-pointer ml-2" @click="marked.splice(index, 1)">
                  <CircleClose />
                </el-icon>
              </div> -->
            </div>
            <vue-tel-input
              class="mt-2"
              style="height: 40px"
              v-model="whatsappRecipient.mobilePhone"
              mode="international"
              v-else
            ></vue-tel-input>
            <div
              v-if="sendWhatsappToMultiple && marked.length > 10"
              class="text-secondary font-weight-600 mt-2"
            >
              and {{ marked.length - 10 }}
              {{ marked.length - 10 > 1 ? "others" : "other" }}
            </div>
          </div>
          <!-- <div class="mt-3">Message</div> -->
          <div class="mt-4">
            <el-input
              type="textarea"
              rows="8"
              placeholder="Enter your message"
              v-model="whatsappmessage"
            ></el-input>
          </div>
        </div>
        <div v-else class="mt-5">
          <AuthenticateWhatsapp />
        </div>
      </template>
      <template #footer v-if="whatsappClientState">
        <el-button :color="primarycolor" @click="sendWhatsapp()" round>
          {{ navigatorLang === "en-US" ? "Send" : $t("people.send") }}
          <img src="../../assets/send-jet.svg" class="ml-2"
        /></el-button>
      </template>
    </el-drawer>
  </div>
</template>

<script>
import { ref, markRaw, inject, computed, watchEffect, onMounted } from "vue";
import axios from "@/gateway/backendapi";
import router from "@/router/index";
import dateFormatter from "../../services/dates/dateformatter";
import VideoPlayIcon from "../../components/svg/VideoPlayIcon.vue";
import deviceBreakpoint from "../../mixins/deviceBreakpoint";
import Table from "@/components/table/Table";
import TableSearch from "@/components/table/TableSearch";
import { InfoFilled } from "@element-plus/icons-vue";
import finish from "../../services/progressbar/progress";
import { ElMessageBox, ElNotification } from "element-plus";
import store from "../../store/store";
import smsComponent from "../groups/component/smsComponent.vue";
import emailComponent from "../groups/component/emailComponent.vue";
import MemberCapExceeded from "@/components/membership/MembershipCapExceeded.vue";
import membershipService from "../../services/membership/membershipservice";
import { whatsappServerBaseURL } from "../../gateway/backendapi";
import AuthenticateWhatsapp from "../../components/whatsapp/AuthenticateWhatsapp.vue";

export default {
  components: {
    Table,
    TableSearch,
    smsComponent,
    emailComponent,
    MemberCapExceeded,
    VideoPlayIcon,
    AuthenticateWhatsapp,
  },
  setup(props) {
    const whatsappRecipient = ref("");
    const whatsappmessage = ref("");
    const showWhatsapp = ref(false);
    const sendWhatsappToMultiple = ref(false);
    const { mdAndUp, lgAndUp, xlAndUp } = deviceBreakpoint();
    const navigatorLang = ref(navigator.language);
    const primarycolor = inject("primarycolor");
    const loading = ref(false);
    const networkError = ref(false);
    const selectedLink = ref(null);
    const tenantCountry = ref({});
    const allcountries = ref([]);
    const showSMS = ref(false);
    const tenantID = ref("");
    const marked = ref([]);
    const markedMembers = ref([]);
    const showEmail = ref(false);
    const contacts = ref([]);
    const searchText = ref("");
    // const allNewConvert = ref([]);
    const videoURL = ref(
      "https://www.youtube.com/embed/zcwna-kshGo?si=08OmWtjLkAbwLXy8"
    );
    const showAddMemberVideo = ref(false);
    const qrCode = ref("");
    const QRCodeDialog = ref(false);
    const allNewConvert = ref(store.getters["membership/allNewConverts"]);
    const NewConvertHeaders = ref([
      { name: "NAME", value: "fullname" },
      { name: "PHONE", value: "phoneNumber" },
      { name: "DATE", value: "date" },
      // { name: "LIFE CYCLE", value: "lifeCycle" },
      { name: "SOURCE", value: "howDidYouAboutUsName" },
      { name: "INTERESTED", value: "interestedInJoining" },
      { name: "INTERACTIONS", value: "interactions" },
      { name: "ACTION", value: "action" },
    ]);
    const membershipCapacityExceeded = ref(false);
    const showAddConvertDialog = ref(false);
    const showSelectFromDB = ref(false);
    const loadingData = ref(false);
    const memberSearchResults = ref([]);
    const currentUser = ref({});
    const newSearchText = ref("");
    const goToAddNewConvert = () => {
      showAddConvertDialog.value = false;
      router.push({ name: "AddNewConvert" });
    };
    const getCurrentSignedInUser = async () => {
      try {
        const res = await membershipService.getSignedInUser();
        tenantID.value = res.tenantId;
        getUser.value = res;
        currentUser.value = res;
      } catch (error) {
        console.log(error);
      }
    };
    getCurrentSignedInUser();
    const showConfirmModal1 = () => {
      ElMessageBox.confirm(
        "This action will permanently delete the firsttimer(s). Continue?",
        "Confirm delete",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "error",
        }
      )
        .then(() => {
          deleteMarked();
        })
        .catch(() => {
          ElNotification({
            type: "info",
            message: "Delete canceled",
          });
        });
    };
    const deleteMarked = async () => {
      try {
        // const IDs = marked.value.map((i) => i.id).join();
        const IDs = marked.value.map((i) => i.id);
        console.log(IDs, "IDS");
        const response = await membershipService.deletePeople(IDs);

        if (
          response &&
          response.response &&
          response.response.toString().toLowerCase().includes("all")
        ) {
          ElNotification({
            type: "success",
            message: "Delete successful",
            duration: 7000,
          });

          allNewConvert.value = allNewConvert.value.filter((item) => {
            const y = marked.value.findIndex((i) => i.id === item.id);
            if (y >= 0) return false;
            return true;
          });
        } else {
          let displayRes =
            response && response.response ? response.response.split("@") : "";
          ElNotification({
            type: "info",
            message: `${displayRes[0]}`,
            duration: 7000,
          });

          if (displayRes && displayRes[1] && displayRes[1] !== "") {
            if (!displayRes[1].includes(",")) {
              allNewConvert.value = allNewConvert.value.filter((item) => {
                return !item.id.includes(displayRes[1]);
              });
            } else {
              let IDs = displayRes[1].split(",");
              allNewConvert.value = allNewConvert.value.filter((item) => {
                const y = IDs.findIndex((i) => i === item.id);
                if (y >= 0) return false;
                return true;
              });
            }
          }
        }
        marked.value = [];
        store.dispatch("membership/setNewConvertData");
        store.dispatch("dashboard/getDashboard");
      } catch (error) {
        console.log(error);
        ElNotification({
          type: "warning",
          message: "Delete failed, please try again",
          duration: 4000,
        });
        // }
      }
    };
    const whatsappClientState = computed(() => {
      return store.getters["communication/isWhatsappClientReady"];
    });
    const clientSessionId = computed(() => {
      if (!store.getters["communication/whatsappSessionId"]) return "";
      return store.getters["communication/whatsappSessionId"];
    });
    const sendTextMessage = async (payload) => {
      try {
        let { data } = await api.post(
          `${whatsappServerBaseURL}send/text?key=${clientSessionId.value}`,
          payload
        );
        console.log(data);

        if (!data.error) {
        }
      } catch (error) {
        console.error(error);
      }
    };
    const displayWhatsappDrawer = (item) => {
      showWhatsapp.value = true;
      if (item) {
        whatsappRecipient.value = item;
        sendWhatsappToMultiple.value = false;
      } else {
        // marked.value = marked.value.filter(i => i.mobilePhone).splice(0, 10)
        sendWhatsappToMultiple.value = true;
      }
    };
    const sendWhatsapp = () => {
      const recipient =
        marked.value && marked.value.length
          ? marked.value.map((i) => ({
              name: `${i?.firstName} ${i?.lastName}`,
              phoneNumber: i.phoneNumber,
            }))
          : [
              {
                name: `${whatsappRecipient.value?.firstName} ${whatsappRecipient.value?.lastName}`,
                phoneNumber: whatsappRecipient.value.phoneNumber,
              },
            ];

      const textPayload = {
        id: recipient,
        message: whatsappmessage.value,
      };
      sendTextMessage(textPayload);
      showWhatsapp.value = false;
      swal(" Success", "Whatsapp message sent successfully!", "success");
    };
    const searchForPerson = (e) => {
      if (newSearchText.value.length >= 3) {
        loadingData.value = true;
        axios
          .get(
            `/api/Membership/GetSearchedUSers?searchText=${newSearchText.value}`
          )
          .then((res) => {
            memberSearchResults.value = res.data;
            loadingData.value = false;
          })
          .catch((err) => {
            loadingData.value = false;
            console.error(err);
            ElNotification({
              title: "Error",
              message: "Failed to fetch members",
              type: "error",
            });
          })
          .finally(() => {
            loadingData.value = false;
          });
      } else {
        memberSearchResults.value = [];
      }
    };

    const selectMember = (member) => {
      showAddConvertDialog.value = false;

      ElMessageBox.confirm(
        `Are you sure you want to add ${
          member.nameResult || member.name
        } as a new convert?`,
        "Confirm",
        {
          confirmButtonText: "Yes, proceed",
          cancelButtonText: "Cancel",
          type: "warning",
          icon: markRaw(InfoFilled),
        }
      )
        .then(() => {
          // ✅ Proceed if user clicks "Yes"
          convertExistingMember(member);
        })
        .catch(() => {
          // ❌ Cancelled
          ElNotification({
            type: "info",
            message: "Conversion cancelled.",
          });
        });
    };

    const convertExistingMember = async (member) => {
      loading.value = true;
      const payload = {
        id: member.id,
        firstName: member.name,
        email: member.email,
        phoneNumber: member.phone,
      };

      try {
        const res = await axios.post("/api/People/AddNewConverts", payload);
        loading.value = false;
        console.log(res, "New Convert added successfully");

        ElNotification({
          type: "success",
          message: `${
            member.nameResult || member.name
          } has been successfully added as a new convert.`,
          duration: 4000,
        });

        // Refresh relevant data
        store.dispatch("membership/setNewConvertData");
        store.dispatch("dashboard/getDashboard");
      } catch (error) {
        loading.value = false;
        ElNotification({
          type: "error",
          message: "Failed to convert existing member. Please try again.",
          duration: 4000,
        });
      } finally {
        loading.value = false;

        finish();
      }
    };

    const watchVideo = () => {
      showAddMemberVideo.value = true;
    };

    const formatDate = (date) => {
      return dateFormatter.monthDayYear(date);
    };
    const showMemberRow = (item) => {
      router.push(`/tenant/people/addnewconvert?id=${item.id}`);
    };
    const addNewConvert = () => {
      router.push("/tenant/people/addnewconvert");
    };
    const handleSearchTextUpdate = (newValue) => {
      searchText.value = newValue;
    };
    const getAllNewConvert = async () => {
      loading.value = true;

      try {
        store.dispatch("membership/setNewConvertData").then((response) => {
          allNewConvert.value = response;
          loading.value = false;
        });
      } catch (err) {
        finish();
        loading.value = false;
        if (err.toString().toLowerCase().includes("network error")) {
          networkError.value = true;
        } else {
          networkError.value = false;
        }
      }
    };
    const copylink2 = () => {
      selectedLink.value.input.setSelectionRange(
        0,
        selectedLink.value.input.value.length
      ); /* For mobile devices */
      selectedLink.value.input.select();

      /* Copy the text inside the text field */
      document.execCommand("copy");
      ElNotification({
        showClose: true,
        message: "Copied to clipboard",
        type: "success",
      });
    };

    const importNewConvert = () => {
      router.push({
        name: "ImportInstruction",
        query: { query: "importnewconvert" },
      });
    };
    const searchNewConvert = computed(() => {
      if (allNewConvert.value === 0 && searchText.value === "")
        return allNewConvert.value;
      return allNewConvert.value.filter((i) =>
        i.fullName.toLowerCase().includes(searchText.value.toLowerCase())
      );
    });
    const sendMarkedMemberSms = () => {
      contacts.value = marked.value
        .filter((i) => i.phoneNumber)
        .map((i) => i.phoneNumber)
        .join();
      showSMS.value = true;
    };

    const sendMarkedMemberEmail = () => {
      showEmail.value = true;
      markedMembers.value = marked.value.map((i) => {
        i.id = i.id;
        return i;
      });
    };
    const handleSelectionChange = (val) => {
      console.log(marked.value, "marked");

      marked.value = val;
      marked.value = val.map((i) => {
        i.phoneNumber =
          i.phoneNumber && i.phoneNumber.substring(0, 1) == "0"
            ? `+${tenantCountry.value.phoneCode}${i.phoneNumber.substring(1)}`
            : `${i.phoneNumber}`;
        return i;
      });
    };

    const newConvertLink = computed(() => {
      if (!tenantID.value) return "";
      return `${window.location.origin}/createnewconvert/${tenantID.value}`;
    });
    const getQrCode2 = async () => {
      try {
        const res = await axios.get(
          `/api/Settings/GetQRCode?link=${window.location.origin}/createnewconvert/${tenantID.value}`
        );
        QRCodeDialog.value = true;
        qrCode.value = res.data;
      } catch (error) {
        console.log(error);
      }
    };
    // const getUser = computed(() => {
    //   if (
    //     !store.getters.currentUser ||
    //     (store.getters.currentUser &&
    //       Object.keys(store.getters.currentUser).length == 0)
    //   )
    //     return "";
    //   return store.getters.currentUser;
    // });

    // watchEffect(() => {
    //   if (getUser.value) {
    //     tenantID.value = getUser.value.tenantId;

    //     if (getUser.value.churchSize >= getUser.value.subscribedChurchSize) {
    //       membershipCapacityExceeded.value = true;
    //     } else {
    //       membershipCapacityExceeded.value = false;
    //     }
    //   }
    // });
    const getUser = computed(() => {
      if (
        !store.getters.currentUser ||
        (store.getters.currentUser &&
          Object.keys(store.getters.currentUser).length == 0)
      )
        return "";
      return store.getters.currentUser;
    });
    watchEffect(() => {
      if (getUser.value) {
        tenantID.value = getUser.value.tenantId;
        currentUser.value = getUser.value;
        if (getUser.value.churchSize >= getUser.value.subscribedChurchSize) {
          membershipCapacityExceeded.value = true;
        } else {
          membershipCapacityExceeded.value = false;
        }
      } else {
        currentUser.value;
      }

      if (
        allcountries.value.length > 0 &&
        getUser.value &&
        Object.keys(getUser.value).length > 0
      ) {
        tenantCountry.value = allcountries.value.find((i) => {
          return i.isoCode == getUser.value.isoCode;
        });
      } else {
        tenantCountry.value = allcountries?.value.find((i) => {
          return i.isoCode == currentUser.value.isoCode;
        });
      }
    });

    const getAllCountries = async () => {
      try {
        let { data } = await axios.get("/api/getallcountries");
        allcountries.value = data;
      } catch (error) {
        console.error(error);
      }
    };

    getAllCountries();

    const showConfirmModal = (id) => {
      ElMessageBox.confirm(
        "Are you sure you want to proceed?",
        "Confirm delete",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "error",
        }
      )
        .then(() => {
          deleteNewConvert(id);
        })
        .catch(() => {
          ElNotification({
            type: "info",
            message: "Delete canceled",
          });
        });
    };
    const deleteNewConvert = (id) => {
      axios
        .delete(`api/People/DeleteNewConvert/${id}`)
        .then((res) => {
          console.log(res);

          ElNotification({
            type: "success",
            message: "New Convert Deleted",
            duration: 3000,
          });
          allNewConvert.value = allNewConvert.value.filter((i) => i.id !== id);
          store.dispatch("membership/removeNewConvertFromStore", id);
        })
        .catch((err) => {
          console.log(err);
          finish();
        });
    };

    onMounted(() => {
      if (allNewConvert.value && allNewConvert.value.length == 0)
        getAllNewConvert();
    });

    return {
      allcountries,
      tenantCountry,
      currentUser,
      whatsappmessage,
      sendTextMessage,
      whatsappClientState,
      clientSessionId,
      showWhatsapp,
      displayWhatsappDrawer,
      sendWhatsapp,
      whatsappRecipient,
      sendWhatsappToMultiple,
      deleteMarked,
      showConfirmModal1,
      InfoFilled,
      loadingData,
      showAddConvertDialog,
      showSelectFromDB,
      memberSearchResults,
      newSearchText,
      searchForPerson,
      selectMember,
      goToAddNewConvert,
      handleSearchTextUpdate,
      mdAndUp,
      navigatorLang,
      lgAndUp,
      xlAndUp,
      primarycolor,
      loading,
      NewConvertHeaders,
      copylink2,
      formatDate,
      networkError,
      showConfirmModal,
      showSMS,
      contacts,
      showEmail,
      markedMembers,
      marked,
      tenantID,
      handleSelectionChange,
      deleteNewConvert,
      sendMarkedMemberEmail,
      sendMarkedMemberSms,
      allNewConvert,
      showMemberRow,
      searchNewConvert,
      searchText,
      importNewConvert,
      getAllNewConvert,
      getUser,
      addNewConvert,
      QRCodeDialog,
      qrCode,
      getQrCode2,
      newConvertLink,
      selectedLink,
      membershipCapacityExceeded,
      videoURL,
      showAddMemberVideo,
      watchVideo,
    };
  },
};
</script>

<style scoped>
.table-top {
  position: absolute;
  /* z-index: 1; */
  top: -40px;
  /* width: 100%; */
  font-weight: 500 !important;
  font-size: 14px;
  background: #fff;
  color: #000000;
  /* border: 1px solid #d4dde3; */
  /* max-width: 83.333333% !important; */
}
.tab-options {
  position: relative;
}

.empty-img {
  width: 30%;
  min-width: 397px;
  margin: auto;
}

.empty-img img {
  width: 100%;
  max-width: 200px;
}
.no-person {
  height: 100%;
  display: flex;
  text-align: center;
}
@media screen and (min-width: 1400px) {
  .main-con {
    width: 90%;
    margin: 0 auto;
  }

  .top {
    height: 90px;
  }

  .no-person {
    height: calc(100% - 90px);
  }
}
</style>
